import { Component, inject, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import { InputFieldComponent } from '../../../../components/ui/inputField/inputField.component';
import { MatIcon } from '@angular/material/icon';
import { CommonModule, Location } from '@angular/common';
import { AddRecipientModal } from '../../../../components/message-modals/add-recipient/add-recipient';
import { PaginationComponent } from '../../../../components/inputs/pagination/pagination.component';
import { ContactsService } from '../../../../services/contacts/contacts.service';
import { TimeZoneService } from '../../../../services/timezone/time-zone.service';
import { SecurePersistStateService } from '../../../../services/storage/local-storage.service';
import { v4 as uuidv4 } from 'uuid';
import { MessageService } from '../../../../services/message/message.service';
import { MessageSubmitButton } from '../../../../components/message-submit-button/message-submit-button.component';
import { AddContactModel } from '../../../../components/messages/add-contacts-modal/add-contacts-modal';
import { UserProfileService } from '../../../../services/user/user-profile.service';
import { MessageTemplate } from '../../../../services/message-templates/message.template';
import { DropdownComponent } from '../../../../components/ui/dropdown/dropdown.component';
import { AddTagsModal } from '../../../../components/messages/add-tags-modal/add-tags-modal';
import { AddOrganisationModal } from '../../../../components/messages/add-organisation-modal/add-organisation-modal';
import { AddSegmentsModal } from '../../../../components/messages/add-segments-modal/add-segments-modal';
import {
  countSMSCharacters,
  validPhoneNumberValidator,
} from '../../../../../utils/utils';
import { NgxMatInputTelComponent } from 'ngx-mat-input-tel';
import { CustomizableButtonComponent } from '../../../../components/ui/customizable-button/customizable-button.component'; // Import validator

@Component({
  selector: 'message-recipient',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule, // Add ReactiveFormsModule here
    MatIcon,
    AddTagsModal,
    InputFieldComponent,
    FormsModule,
    AddSegmentsModal,
    AddRecipientModal,
    AddOrganisationModal,
    PaginationComponent,
    MessageSubmitButton,
    AddContactModel,
    DropdownComponent,
    NgxMatInputTelComponent,
    CustomizableButtonComponent,
  ],
  templateUrl: './message-recipient.component.html',
  styleUrls: ['./message-recipient.component.css'],
})
export class MessageRecipient implements OnInit, OnDestroy {
  myForm: FormGroup;
  params: FormGroup | any;
  getTemplate: FormGroup;
  submitted: boolean = false;
  recipient_view: boolean = true;
  content_view: boolean = true;
  schedule_view: boolean = false;
  add_recipient: boolean = false;
  add_tags: boolean = false;
  add_organization: boolean = false;
  add_segment: boolean = false;
  isChecked: boolean = false;
  isDraft: boolean = false;
  selected_tags: any[] = [];
  selected_contacts: any[] = [];
  selected_organisation: any[] = [];
  selected_segments: any[] = [];
  selected_template: string = '';
  messageValue: string = '';
  messageSubject: string = '';
  formError: boolean = false;
  searchParam: string = '';
  template_list: any[] = [];
  loading: boolean = false;
  isEdit: boolean = false;
  filteredData: any[] = [];
  textareaControl = new FormControl('');
  subjectControl = new FormControl('');
  searchControl = new FormControl('');
  urlParam: number = 0;
  selectedMessageType: string = 'instant';
  messageType = new FormControl('');
  timeZones: any[] = [];
  selected_zone: string = '';
  templateValue: string = '';
  today = new Date().toISOString().split('T')[0];
  selectedTimeZone: any = null; // Store the selected time zone
  schedule_date: string = ''; // Store the selected date
  schedule_time: string = ''; // Store the selected time
  phoneRecipients: string[] = [];

  userService = inject(UserProfileService);

  //Form fields error
  subject_error: string = '';
  template_error: string = '';
  body_error: string = '';
  contact_error: string = '';
  tags_error: string = '';
  organization_error: string = '';
  segment_error: string = '';
  time_zone_error: string = '';
  s_date_error: string = '';
  s_time_error: string = '';
  phoneNumberError = '';
  private formErrorTimeoutId: ReturnType<typeof setTimeout> | undefined;

  @ViewChild(NgxMatInputTelComponent)
  phoneInput!: NgxMatInputTelComponent;

  get organizationId() {
    return this.userService.organizationId;
  }

  get organizationName() {
    return this.userService.getInstitutionName;
  }

  get phoneNumbers() {
    return this.phoneRecipients;
  }

  handleScheduleDate(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.schedule_date = input.value;
  }

  handleScheduleTime(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.schedule_time = input.value;
  }

  handleTimeZone(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.selected_zone = input.value;
  }

  discard() {
    this.isDraft = false;
    this.location.back();
  }

  closeDraft() {
    this.isDraft = false;
  }
  setDraft() {
    this.isDraft = true;
  }
  recipientView() {
    this.recipient_view = !this.recipient_view;
  }
  scheduleView() {
    this.schedule_view = !this.schedule_view;
  }
  contentView() {
    this.content_view = !this.content_view;
  }

  closeModal() {
    this.add_recipient = false;
  }
  openModal() {
    this.add_recipient = true;
  }

  openTags() {
    this.add_tags = true;
  }
  closeTag() {
    this.add_tags = false;
    this.add_organization = false;
    this.add_segment = false;
  }
  openSegment() {
    this.add_segment = true;
  }
  closeSegment() {
    this.add_segment = false;
  }
  openOrganization() {
    this.add_organization = true;
  }
  closeOrganization() {
    this.add_organization = false;
  }

  onCheckboxChange(event: any) {
    this.isChecked = event?.target?.checked;
  }

  contact_list: any[] = [];
  tag_list: any[] = [];
  organisation_list: any[] = [];
  segment_list: any[] = [];

  contactsService = inject(ContactsService);

  allSelected = false;
  allSelectedContacts = false;
  allSelectedOrganisation = false;
  allSelectedSegment = false;

  toggleAll(event: Event) {
    this.allSelected = (event.target as HTMLInputElement).checked;

    // Retrieve selected tags from local storage
    const storedTags: string[] =
      this.localStorageService.getItem('selected_tags') || [];

    this.tag_list.forEach((tag) => {
      // Check if the tag exists in local storage and set its selected state
      tag.selected = this.allSelected ? storedTags.includes(tag.id) : false;
    });

    // Log the selected tags after toggling
    this.logSelectedTags();
  }

  checkSelection() {
    this.allSelected = this.tag_list.every((tag) => tag.selected);
    this.logSelectedTags();
  }

  logSelectedTags() {
    const selectedTags = this.tag_list.filter((tag) => tag.selected);
    this.selected_tags = selectedTags;
  }

  toggleAllSegments(event: Event) {
    this.allSelectedSegment = (event.target as HTMLInputElement).checked;
    this.segment_list.forEach(
      (seg) => (seg.selected = this.allSelectedSegment)
    );
    this.logSelectedSegments();
  }

  checkSelectionSegments() {
    this.allSelectedSegment = this.segment_list.every((seg) => seg.selected);
    this.logSelectedSegments();
  }

  logSelectedSegments() {
    const segments = this.segment_list.filter((seg) => seg.selected);
    this.selected_segments = segments;
  }

  handleSelectedContactsChange(selectedContacts: any[]) {
    this.selected_contacts = selectedContacts;
  }

  handleSelectedTagsChange(selectedTags: any[]) {
    this.selected_tags = selectedTags;
  }

  handleSelectedOrgsChange(selectedOrgs: any[]) {
    this.selected_organisation = selectedOrgs;
  }

  handleSelectedSegmentsChange(selectSegments: any[]) {
    this.selected_segments = selectSegments;
  }

  toggleAllOrganisation(event: Event) {
    this.allSelectedOrganisation = (event.target as HTMLInputElement).checked;
    this.organisation_list.forEach(
      (tag) => (tag.selected = this.allSelectedOrganisation)
    );
    this.logSelectedOrganisation();
  }

  checkSelectionOrganisation() {
    this.allSelectedOrganisation = this.organisation_list.every(
      (org) => org.selected
    );
    this.logSelectedOrganisation();
  }

  logSelectedOrganisation() {
    const selected = this.organisation_list.filter((org) => org.selected);
    this.selected_organisation = selected;
  }

  fetchContacts() {
    this.contactsService.fetchContacts({
      'fullName.contains': this.searchParam,
    });
    this.contactsService.getContacts.subscribe({
      next: (data) => {
        this.contact_list = data.map((contacts) => ({
          ...contacts,
          selected: false,
        }));
      },
      error: (err) => {},
    });
  }

  fetchTags() {
    this.contactsService.fetchTags();
    this.contactsService.getTags.subscribe({
      next: (tags) => {
        this.tag_list = tags.map((tag) => ({ ...tag, selected: false }));
      },
      error: () => {},
    });
  }

  // appendAttribute(value: string) {}
  appendAttribute(name: string) {
    this.textareaControl.setValue(
      this.messageValue?.trimEnd() + ' ' + `{${name}}`
    );
  }

  onTextareaChange(value: string) {
    this.messageValue === value;
  }

  onSubjectChange(value: string) {
    this.messageSubject === value;
    this.subject_error = '';
  }

  onRadioChange(_event: any) {}

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private fb: FormBuilder,
    private timeZoneService: TimeZoneService,
    private localStorageService: SecurePersistStateService,
    private messageService: MessageService,
    private location: Location,
    private messageTemplates: MessageTemplate,
    private route: ActivatedRoute
  ) {
    this.myForm = this.builder.group({
      contact: new FormControl(''),
      tag: new FormControl(''),
      organization: new FormControl(''),
      segment: new FormControl(''),
      template: new FormControl(''),
      messageBody: new FormControl('', Validators.required),
      instantMessage: new FormControl(false),
      scheduleMessage: new FormControl(false),
       phoneNumber: new FormControl(''), // Add phoneNumber here
    });

    this.getTemplate = this.fb.group({
      template: ['', Validators.required],
      messageBody: ['', Validators.required],
    });

    // Apply the ngx-mat-input-tel validator to the phoneNumber control
    this.myForm.get('phoneNumber')?.addValidators([validPhoneNumberValidator]);
  }

  // === Phone Number Management ===
  /**
   * Add a new phone number input to the recipients list
   */
  addPhoneNumber() {
    const phoneNumberControl = this.myForm.get('phoneNumber');
    const isValid = phoneNumberControl?.valid;
    if (!isValid) {
      this.phoneNumberError = 'Phone number not valid';
    } else {
      this.phoneNumberError = '';
    }

    const phoneNumber = phoneNumberControl?.value;
    if (phoneNumber && isValid) {
      this.phoneRecipients.push(phoneNumber);
      phoneNumberControl?.reset(); // Use reset() to clear the FormControl (and UI)
      phoneNumberControl?.markAsPristine(); // Reset pristine state
      phoneNumberControl?.markAsUntouched(); // Reset touched state
      this.phoneInput.reset();
    }
  }

  /**
   * Remove a phone number input from the recipients list
   * @param index Index of the phone number to remove
   */
  removePhoneNumber(index: number) {
    if (this.phoneRecipients.length > 0) {
      this.phoneRecipients = this.phoneRecipients.filter(
        (_, idx) => idx !== index
      );
    }
  }

  handleMessagePreview() {
    window.scrollTo(0, 0);
    this.localStorageService.setItem('preivew', {
      name: 'message',
      value: this.messageValue,
    });

    const formState = {
      submitted: this.submitted,
      message_subject: this.messageSubject,
      recipient_view: this.recipient_view,
      content_view: this.content_view,
      schedule_view: this.schedule_view,
      add_recipient: this.add_recipient,
      add_tags: this.add_tags,
      add_organization: this.add_organization,
      add_segment: this.add_segment,
      isChecked: this.isChecked,
      // isDraft: this.isDraft,
      selected_tags: this.selected_tags,
      selected_contacts: this.selected_contacts,
      selected_organisation: this.selected_organisation,
      selected_segments: this.selected_segments,
      selected_template: this.selected_template,
      selectedTemplate: this.templateValue,
      messageValue: this.messageValue,
      filteredData: this.filteredData,
      selectedMessageType: this.selectedMessageType,
      selected_zone: this.selected_zone,
      schedule_date: this.schedule_date,
      schedule_time: this.schedule_time,
      selectedTimeZone: this.selectedTimeZone,
    };

    // Persist the form state
    this.localStorageService.setItem('formState', formState);

    if (this.urlParam) {
      this.router.navigate([`/organization/messages/preview`], {
        queryParams: { payload: this.urlParam },
      });
    } else {
      this.router.navigate(['/organization/messages/preview']);
    }
  }

  getSearchParam(e: any) {
    this.searchParam = e;
    this.fetchContacts();
  }

  formatDate(inputDate: string): string {
    const date = new Date(inputDate);

    // Get month, day, and year
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    // Format as MM/DD/YYYY
    return `${year}-${month}-${day}`;
  }

  fetchContactsBulk(data: string[]): void {
    if (data.length) {
      this.contactsService.fetchContactsBulk({
        'uuid.in': data,
      });

      this.contactsService.getContactsUuid.subscribe({
        next: (data) => {
          this.selected_contacts = data;
        },
        error: (err) => {
        },
      });
    }
  }

  fetchTagsBulk(data: string[]): void {
    if (data.length) {
      this.contactsService.fetchTagsBulk({
        'uuid.in': data,
      });

      this.contactsService.getTagsBulk.subscribe({
        next: (data) => {
          this.selected_tags = data;
        },
        error: (err) => {
        },
      });
    }
  }

  fetchOrgBulk(input: string[]): void {
    if (input.length) {
      this.contactsService.fetchOrganizationsBulk({
        'uuid.in': input,
      });

      this.contactsService.getOrganizationsBulk.subscribe({
        next: (data) => {
          this.selected_organisation = data;
        },
        error: (err) => {
        },
      });
    }
  }

  fetchSegBulk(input: string[]): void {
    if (input.length) {
      this.contactsService.fetchBulkSegments({
        'uuid.in': input,
      });

      this.contactsService.getBulkSegments.subscribe({
        next: (data) => {
          this.selected_segments = data;
        },
        error: (err) => {
        },
      });
    }
  }

  loadMessageDetails(id: string): void {
    this.messageService.fetchDetailedMessage(id);

    this.messageService.detailedMessage.subscribe(
      (data: any) => {
        this.messageSubject = data?.messageSubject;
        this.messageValue = data?.content;
        this.content_view = true;
        this.urlParam = data.id;

        if (data?.messageType === 'SCHEDULE') {
          this.schedule_view = true;
          this.selectedMessageType = data?.messageType.toLowerCase();
          this.selected_zone = data?.scheduleTimeZone;
          this.schedule_date = data?.scheduleDate;
          this.schedule_time = data?.scheduleTime;
        }

        const contact_list = data.engagementContactLists
          .filter((result: any) => result.contactUuids != null)
          .map((result: any) => result.contactUuids);

        const tag_list = data.engagementContactLists
          .filter((result: any) => result.tagUuids != null)
          .map((result: any) => result.tagUuids);

        const org_list = data.engagementContactLists
          .filter((result: any) => result.companyUuids != null)
          .map((result: any) => result.companyUuids);

        const seg_list = data.engagementContactLists
          .filter((result: any) => result.segmentUuids != null)
          .map((result: any) => result.segmentUuids);

        this.fetchContactsBulk(contact_list);
        this.fetchTagsBulk(tag_list);
        this.fetchOrgBulk(org_list);
        this.fetchSegBulk(seg_list);
      },
      (error) => {
      }
    );
  }

  ngOnInit() {
    const storedFormState = this.localStorageService.getItem('formState');

    // if some organizations were selected to send a message to them
    this.messageService.selectedOrganizations &&
      this.handleSelectedOrgsChange(this.messageService.selectedOrganizations);

    this.messageService.selectedTags &&
      this.handleSelectedTagsChange(this.messageService.selectedTags);

    this.messageService.selectedSegments &&
      this.handleSelectedSegmentsChange(this.messageService.selectedSegments);

    if (storedFormState) {
      this.submitted = storedFormState.submitted || false;
      this.messageSubject = storedFormState.message_subject || '';
      this.recipient_view = storedFormState.recipient_view || false;
      this.content_view = storedFormState.content_view || false;
      this.schedule_view = storedFormState.schedule_view || false;
      this.add_recipient = storedFormState.add_recipient || false;
      this.add_tags = storedFormState.add_tags || false;
      this.add_organization = storedFormState.add_organization || false;
      this.add_segment = storedFormState.add_segment || false;
      this.isChecked = storedFormState.isChecked || false;
      // this.isDraft = storedFormState.isDraft || false;
      this.selected_tags = storedFormState.selected_tags || [];
      this.selected_contacts = storedFormState.selected_contacts || [];
      this.selected_organisation = storedFormState.selected_organisation || [];
      this.selected_segments = storedFormState.selected_segments || [];
      this.selected_template = storedFormState.selected_template || '';
      this.messageValue = storedFormState.messageValue || '';
      this.filteredData = storedFormState.filteredData || [];
      this.selectedMessageType =
        storedFormState.selectedMessageType || 'instant';
      this.selected_zone = storedFormState.selected_zone || '';
      this.schedule_date = storedFormState.schedule_date || '';
      this.schedule_time = storedFormState.schedule_time || '';
      this.selectedTimeZone = storedFormState.selectedTimeZone || null;
    }

    this.fetchContacts();
    this.messageTemplates.fetchTemplates();
    this.fetchTags();
    // this.fetchOrganiztion();
    this.contactsService.fetchOrganizations();
    this.contactsService.fetchSegments();
    this.contactsService.getSegments;
    this.timeZones = this.timeZoneService.getTimeZones();
    this.selectedTimeZone = this.timeZones[0].timezone;

    this.messageTemplates.getTemplates.subscribe((data) => {
      this.template_list = data;
    });

    this.contactsService.getOrganizations.subscribe((organizations: any[]) => {
      this.organisation_list = organizations;
    });

    this.contactsService.getSegments.subscribe((segments: any[]) => {
      this.segment_list = segments;
    });

    // this.getTemplate
    //   .get('template')
    //   ?.valueChanges.subscribe((value: string) => {
    //     this.selected_template = value; // Assign the selected value to the variable
    //   });

    this.route.queryParams.subscribe((params) => {
      const data = params['items'];
      const subject = params['subject'];
      const msgContent = params['msgContent'];
      const msgType = params['msgType'];
      const time_zone = params['selected_zone'];
      const selected_date = params['selected_date'];
      const schedule_time = params['selected_time'];

      if (subject) {
        this.content_view = true;
        this.messageSubject = subject;
      }

      if (msgType === 'SCHEDULE') {
        this.selected_zone = time_zone;
        this.schedule_date = this.formatDate(selected_date);
        this.schedule_time = schedule_time;
      }

      if (msgContent) {
        this.messageValue = msgContent;
      }
      if (msgType) {
        this.schedule_view = true;
        this.selectedMessageType = msgType.toLowerCase();
      }
      // 'schedule' ? 'SCHEDULE' : 'INSTANT'
      if (data) {
        const decodedString = decodeURIComponent(data); // Decode URL encoding
        const from_contact = JSON.parse(decodedString); // Parse JSON

        if (from_contact.length) {
          this.recipient_view = true;
          this.selected_contacts = [...this.selected_contacts, ...from_contact];
        }
      }
    });

    this.route.queryParams.subscribe((params) => {
      const data = params['items'];
      const template = params['template'];
      const edit = params['payload'];
      this.messageService.fetchDetailedMessage(edit);

      if (template) {
        this.content_view = true;
        const templates = JSON.parse(template); // Parse JSON
        this.templateValue = templates.id; // Assign the selected value to the variable
        this.selected_template = templates.name;
        this.messageValue = templates.content;
      }
      if (edit) {
        this.recipient_view = true;
        this.isEdit = true;
        this.loadMessageDetails(edit);
      }

      if (data) {
        const decodedString = decodeURIComponent(data); // Decode URL encoding
        const from_contact = JSON.parse(decodedString); // Parse JSON

        if (from_contact.length) {
          this.recipient_view = true;
          this.selected_contacts = from_contact;
        }
      }
    });
  }

  // Method to show the error temporarily
  triggerFormError(duration: number = 3000) {
    // 3000 ms = 3 seconds
    this.formError = true;

    // Set a timer to reset the error after the specified duration
    if (this.formErrorTimeoutId) {
      clearTimeout(this.formErrorTimeoutId);
    }
    this.formErrorTimeoutId = setTimeout(() => {
      this.formError = false;
      this.formErrorTimeoutId = undefined;
    }, duration);
  }

  postBody(status: 'Completed' | 'Draft' | 'Pending') {
    const uniqueId = uuidv4();
    const date = new Date();

    // const mapContacts = this.selected_contacts.map((res) => ({
    //   contactUuids: res?.uuid,
    // }));
    const mapContacts = this.selected_contacts.map((res) => res?.uuid);

    // const mapTags = this.selected_tags.map((res) => ({ tagUuids: res.uuid }));
    const mapTags = this.selected_tags.map((res) => res.uuid);

    // const selectOrg = this.selected_organisation.map((res) => ({
    //   companyUuids: res.uuid,
    // }));
    const selectOrg = this.selected_organisation.map((res) => res.uuid);

    // const selectSegs = this.selected_segments.map((res) => ({
    //   segmentUuids: res.uuid,
    // }));
    const selectSegs = this.selected_segments.map((res) => res.uuid);

    return {
      flash: false,
      name: this.messageSubject,
      characterCount: this.getMessageBodyCount.totalCharacters,
      from: this.organizationName,
      intermediateReport: true,
      content: this.messageValue,
      uuid: uniqueId,
      sendAt: date.toISOString(),
      createdAt: date.toISOString(),
      countryCode: 'SG',
      organisationId: this.organizationId,
      messageSubject: this.messageSubject,
      messageTemplate: this.templateValue,
      messageType:
        this.selectedMessageType === 'schedule' ? 'SCHEDULE' : 'INSTANT',
      status: status,
      scheduleTimeZone:
        this.selectedMessageType === 'schedule' ? this.selected_zone : '',
      scheduleDate:
        this.selectedMessageType === 'schedule'
          ? new Date(this.schedule_date)
          : '',
      scheduleTime:
        this.selectedMessageType === 'schedule' ? this.schedule_time : '',
      // engagementContactLists: [
      //   ...mapContacts,
      //   ...mapTags,
      //   ...selectOrg,
      //   ...selectSegs,
      // ],
      // engagementContactLists: [
      //   {
      //     contactUuids: mapContacts.join(),
      //     tagUuids: mapTags.join(),
      //     companyUuids: selectOrg.join(),
      //     segmentUuids: selectSegs.join(),
      //   },
      // ],
      batchContactsPayload: {
        contactUuids: mapContacts,
        tagUuids: mapTags,
        companyUuids: selectOrg,
        segmentUuids: selectSegs,
      },
    };
  }

  removeStorage() {
    localStorage.removeItem('selectedContacts');
    localStorage.removeItem('selectedOrg');
    localStorage.removeItem('selectedSegments');
    localStorage.removeItem('selectedTags');
  }

  postBodyUpdate(status: 'Completed' | 'Draft' | 'Pending') {
    const uniqueId = uuidv4();
    const date = new Date();

    const mapContacts = this.selected_contacts.map((res) => ({
      contactUuids: res?.uuid,
    }));

    const mapTags = this.selected_tags.map((res) => ({ tagUuids: res.uuid }));

    const selectOrg = this.selected_organisation.map((res) => ({
      companyUuids: res.uuid,
    }));

    const selectSegs = this.selected_segments.map((res) => ({
      segmentUuids: res.uuid,
    }));

    return {
      id: this.urlParam,
      content: this.messageValue,
      modifiedAt: date.toISOString(),
      messageSubject: this.messageSubject,
      messageTemplate: this.templateValue,
      messageType:
        this.selectedMessageType === 'schedule' ? 'SCHEDULE' : 'INSTANT',
      status: status,
      scheduleTimeZone:
        this.selectedMessageType === 'schedule' ? this.selected_zone : '',
      scheduleDate:
        this.selectedMessageType === 'schedule'
          ? new Date(this.schedule_date)
          : '',
      scheduleTime:
        this.selectedMessageType === 'schedule' ? this.schedule_time : '',
      // engagementContactLists: [
      //   ...mapContacts,
      //   ...mapTags,
      //   ...selectOrg,
      //   ...selectSegs,
      // ],
    };
  }

  deleteMessage() {
    this.messageService.deleteMessage(this.urlParam?.toString()).subscribe({
      next: () => {},
      error: () => {},
    });
  }

  saveDraft() {
    if (this.isEdit) {
      this.deleteMessage();
    }
    this.messageService.createMessage(this.postBody('Draft')).subscribe({
      next: () => {
        // Clear formState from localStorage
        localStorage.removeItem('formState');
        this.removeStorage();
        this.router.navigate(['/organization/messages'], { queryParams: { tab: 'inactive' } });

        this.submitted = false;
      },
      error: (err) => {
        this.submitted = false;
      },
    });
  }

  validateDate(inputDate: string): boolean {
    const today = new Date();
    const selectedDate = new Date(inputDate);

    // Remove the time component for accurate comparison
    today.setHours(0, 0, 0, 0);

    // Return true if the date is valid (in the future), false otherwise
    return selectedDate >= today;
  }

  onSubmit() {
    this.submitted = true;

    if (!this.messageSubject) {
      this.subject_error = 'Message subject field is required!';
    } else {
      this.subject_error = '';
    }

    if (!this.messageValue) {
      this.body_error = 'Message body field is required!';
    } else {
      this.body_error = '';
    }

    if (this.selectedMessageType === 'schedule') {
      if (!this.selected_zone) {
        this.time_zone_error = 'Message schedule timezone required';
      } else {
        this.time_zone_error = '';
      }
      if (!this.schedule_date) {
        this.s_date_error = 'Message schedule date required';
      } else {
        this.s_date_error = '';
      }
      if (!this.validateDate(this.schedule_date)) {
        this.s_date_error = 'Invalid date body';
        throw Error('');
      } else {
        this.s_date_error = '';
      }
      if (!this.schedule_time) {
        this.s_time_error = 'Message schedule time required';
        throw Error('');
      } else {
        this.s_time_error = '';
      }
    }

    if (this.messageValue !== '' && this.messageSubject !== '') {
      const d = this.postBody(
        this.selectedMessageType === 'schedule' ? 'Pending' : 'Completed'
      );
      if (this.isEdit) {
        this.deleteMessage();
      }
      this.messageService
        .createMessage(
          this.postBody(
            this.selectedMessageType === 'schedule' ? 'Pending' : 'Completed'
          )
        )
        .subscribe({
          next: () => {
            // Clear formState from localStorage
            localStorage.removeItem('formState');
            this.removeStorage();
            this.router.navigate(['/organization/messages']);
            this.submitted = false;
          },
          error: (err) => {
            this.submitted = false;
          },
        });

      this.messageService.loading.subscribe((loading) => {
        this.loading = loading;
      });
    } else {
      this.triggerFormError();
      this.submitted = false;
    }
  }

  ngOnDestroy() {
    if (this.formErrorTimeoutId) {
      clearTimeout(this.formErrorTimeoutId);
    }
  }

  emailErrorMsg(controlName: string) {
    const control = this.myForm.get(controlName);
    if (control?.errors) {
      if (control.errors['required']) {
        return `${
          controlName.charAt(0).toUpperCase() + controlName.slice(1)
        } is required`;
      }
      if (control.errors['email']) {
        return 'This must be a valid email';
      }
    }
    return '';
  }

  onMessageChange(e: string) {
    if (this.template_list.length) {
      const select = this.template_list?.find(
        (res) => res.id.toString() === e.toString()
      );

      this.selected_template = select.name;
      this.messageValue = select.content;
    }
  }

  tempIdToVar(e: string) {
    if (this.template_list) {
      return this.template_list.find((res) => res.id.toString() === e);
    }
  }

  get getMessageBodyCount() {
    return countSMSCharacters(this.messageValue);
  }
}
